<template>
    <button 
    class="btn" 
    type="submit" 
    :disabled="disabled || loading" 
    :data-toggle="tooltip ? 'tooltip' : null" 
    :data-placement="tooltip ? tooltipPlacement : null" 
    :title="tooltip">
        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
        <template v-else="!loading"><slot></slot></template>
    </button>
</template>

<script>
export default {
    name: "SubmitButton",

    props: {
        loading: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: null
        },
        tooltipPlacement: {
            type: String,
            default: "top"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
        }
    },

    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    // Could I get this component to watch the parent form's loading property programatically so I don't have to pass it in every time?
}
</script>

<style>

</style>